import { all, fork } from 'redux-saga/effects';
import authSaga from './comp/login/authSaga';
import { globalSagas } from './comp/global/globalReducer';

export default function* rootSaga() {
  yield all([fork(authSaga), fork(globalSagas)]);
}
